import React, { useEffect } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import PageBanner from './PageBanner';
import FeaturedProducts from '../FeaturedProducts';
import Products from '../Products';

const StoresGridSection = styled.section`
  padding: 1rem 2rem 3rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const StoresGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5rem;
`;

const StoreCard = styled(motion.a)`
  background: white;
  border-radius: 20px;
  padding: 2rem 1.5rem;
  text-align: center;
  text-decoration: none;
  color: #333;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border: 3px solid transparent;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: #ff6b6b;
    box-shadow: 0 15px 35px rgba(255, 107, 107, 0.25);
  }

  .icon {
    font-size: 2.5rem;
    margin-bottom: 0.8rem;
  }

  h3 {
    color: #ff6b6b;
    margin: 0 0 0.5rem 0;
    font-size: 1.3rem;
  }

  p {
    color: #666;
    font-size: 0.95rem;
    margin: 0 0 1.2rem 0;
    line-height: 1.4;
  }

  .badge-btn {
    background: #ff6b6b;
    color: white;
    padding: 0.5rem 1.2rem;
    border-radius: 20px;
    font-weight: bold;
    font-size: 0.9rem;
  }
`;

const stores = [
  {
    icon: '👕',
    title: 'Printful Store',
    desc: 'Official direct apparel, bandanas, bikinis, and custom merch.',
    link: 'https://chikinlady.printful.me',
    color: '#1a1a1a'
  },
  {
    icon: '🧡',
    title: 'Etsy Handmade',
    desc: 'Unique handcrafted chicken gifts, accessories, and boutique items.',
    link: 'https://chikinlady.etsy.com',
    color: '#f56400'
  },
  {
    icon: '🛍️',
    title: 'eBay Store',
    desc: 'Exclusive finds, collectibles, and special limited runs.',
    link: 'https://www.ebay.com/usr/chikinlady',
    color: '#86d4f6'
  },
  {
    icon: '🎨',
    title: 'OpenSea NFTs',
    desc: 'Official digital chicken art collection and blockchain collectibles.',
    link: 'https://opensea.io/0x97a662d64b1ee104dd68dcb85f24f40b4c907a39',
    color: '#2081e2'
  }
];

const ShoppingPage = () => {
  useEffect(() => {
    document.title = 'Chikin Lady Shopping & Stores | Official Merchandise';
  }, []);

  return (
    <>
      <PageBanner
        badge="🛍️ Official Storefronts"
        title="Chikin Lady Shopping Hub"
        subtitle="Shop all official merchandise, exclusive farm apparel, and collectibles across our partner platforms or right here on our website!"
        primaryText="🛒 Browse Catalog Below"
        primaryLink="#products"
        secondaryText="🐔 Main Site"
        secondaryLink="/"
      />

      <StoresGridSection>
        <StoresGrid>
          {stores.map((s, idx) => (
            <StoreCard
              key={idx}
              href={s.link}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ y: -6, scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <div className="icon">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
              <span className="badge-btn" style={{ background: s.color }}>
                Visit Store →
              </span>
            </StoreCard>
          ))}
        </StoresGrid>
      </StoresGridSection>

      <FeaturedProducts />
      <Products />
    </>
  );
};

export default ShoppingPage;
